import type { SWRConfiguration, SWRResponse } from 'swr'
import useSWR from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { ListLikePostByIdPostId } from 'shared/types/list-likes-post-by-post-id'
import type { LikeInterface } from 'modules/comments/api/types'

export const getLastLikesKey = (postId: number): string =>
  `/api/community/post/${postId}/list-last-few-likes`

export const usePostLikes = ({
  postId,
  enabled = true,
  config,
}: {
  postId: number
  enabled?: boolean
  config?: SWRConfiguration<LikeInterface[], Error>
}): SWRResponse<
  ListLikePostByIdPostId[],
  any,
  SWRConfiguration<LikeInterface[], Error> | undefined
> => {
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    ListLikePostByIdPostId[]
  >({
    method: RequestMethodsEnum.get,
  })

  return useSWR(enabled ? getLastLikesKey(postId) : null, fetcher, config)
}
